<div class="snackbar-container">
  <span matSnackBarLabel>
    {{data.message}}
  </span>
  <span matSnackbarActions>
    <button mat-raised-button matSnackBarAction color="primary" (click)="snackBarRef.dismissWithAction()">Download</button>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismiss()"><mat-icon>close</mat-icon></button>
  </span>
</div>